import React from 'react';
import {useIntl} from 'react-intl';
import {SharedReportLoginContextProvider} from './SharedReportLoginContext';

const SharedReportLoginWrapper = ({sharedId, refetch}) => {
	const {formatMessage} = useIntl();

	return (
		<div className="login-wrapper">
			<div className="description-panel">
				<div className="description">
					<a href="https://www.forecast.app/">
						<div className="logo" />
						<span>Forecast</span>
					</a>
					<h2>{formatMessage({id: 'running_reminder_modal.greeting'})},</h2>
					<h2>{formatMessage({id: 'login.welcome-greeting'})}</h2>
				</div>
			</div>
			<SharedReportLoginContextProvider sharedId={sharedId} refetch={refetch}></SharedReportLoginContextProvider>
		</div>
	);
};

export default SharedReportLoginWrapper;
